import { render } from "./LabelEditWidget.vue?vue&type=template&id=40540c16&ts=true"
import script from "./LabelEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./LabelEditWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__